import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../css/menuiconlyer.css";
import "../css/getintouch.css";
import logo from "../assets/images/CDC FINAL LOGO - 01.png";
import pinImage from "../assets/images/paper-clip_2115630.png";
import { motion } from "framer-motion";
import { HashLink } from "react-router-hash-link";

const NavBar = () => {
  const [topNav, setTopNav] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const wordVariants = {
    hidden: { x: 100, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 15,
        delay: i * 0.05,
      },
    }),
  };

  const dropdownVariants = {
    hidden: {
      opacity: 0,
      x: 20,
      rotate: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      x: 0,
      rotate: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };

  const mobileDropdownVariants = {
    hidden: {
      opacity: 0,
      height: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    visible: {
      opacity: 1,
      height: "auto",
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };

  const menuItems = [
    { text: "home", chars: ["h", "o", "m", "e"], link: "/" },
    {
      text: "about us",
      chars: ["a", "b", "o", "u", "t", " ", "u", "s"],
      link: "/about",
    },
    {
      text: "imaging services",
      chars: [
        "i",
        "m",
        "a",
        "g",
        "i",
        "n",
        "g",
        " ",
        "s",
        "e",
        "r",
        "v",
        "i",
        "c",
        "e",
        "s",
      ],
      link: "/imaging-services",
    },
    {
      text: "for patients",
      chars: ["f", "o", "r", " ", "p", "a", "t", "i", "e", "n", "t", "s"],
      dropdown: [
        { text: "make a payment", link: "/make-a-payment" },
        { text: "schedule appointment", link: "/for-patient" },
        { text: "exam prep", link: "/for-patient#exam-prep" },
        { text: "patient forms", link: "/for-patient#forms" },
        { text: "billing & insurance", link: "/for-patient#insurance" },
        { text: "medical records", link: "/for-patient#records" },
        { text: "patient resources", link: "/for-patient#patient-rosource" },
        { text: "satisfaction survey", link: "/for-patient#pss" },
        { text: "patient reviews", link: "/patient-reviews" },
      ],
    },
    {
      text: "for clinicians",
      chars: [
        "f",
        "o",
        "r",
        " ",
        "c",
        "l",
        "i",
        "n",
        "i",
        "c",
        "i",
        "a",
        "n",
        "s",
      ],
      dropdown: [
        { text: "refer patient", link: "/for-clinicians" },
        { text: "physician order form", link: "/for-clinicians#form" },
        { text: "clinician resources", link: "/for-clinicians#survey" },
        {
          text: "satisfaction survey",
          link: "/for-clinicians#resources#resources",
        },
      ],
    },
    {
      text: "contact us",
      chars: ["c", "o", "n", "t", "a", "c", "t", " ", "u", "s"],
      link: "/contact",
    },
    {
      text: "portal",
      chars: ["p", "o", "r", "t", "a", "l"],
      link: "https://pacs.citrusdiagnosticcenter.com/AccessNET/Framework/AccessLogin.aspx?ReturnUrl=%2faccessnet%2fImageWEB%2fExamLoad.aspx",
    },
  ];

  useEffect(() => {
    if (topNav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [topNav]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMouseEnter = (index) => {
    if (window.innerWidth >= 1024) {
      setActiveDropdown(index);
    }
  };

  const handleMouseLeave = (index) => {
    if (window.innerWidth >= 1024) {
      setActiveDropdown((prev) => (prev === index ? null : prev));
    }
  };

  const handleDropdownToggle = (index) => {
    if (window.innerWidth < 1024) {
      setActiveDropdown((prev) => (prev === index ? null : index));
    }
  };

  const handleLogoClick = () => {
    if (topNav) {
      setTopNav(false);
    }
  };

  const handleBackClick = () => {
    navigate("/imaging-services");
    if (topNav) {
      setTopNav(false);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled || topNav ? "" : "bg-transparent"
        }`}
      >
        <div className="flex justify-between items-center md:px-14 pe-5 ps-8 py-4">
          <div className="z-40">
            {location.pathname.startsWith("/services/") ? (
              isScrolled ? null : (
                <div className="flex items-center justify-center overflow-hidden">
                  <button
                    onClick={handleBackClick}
                    className="relative flex items-center justify-center xl:w-52 xl:h-52 md:w-40 md:h-40 w-20 h-20 rounded-full border-2 border-[#cfa751]
               bg-white hover:bg-[#cfa751] transition-all duration-500 ease-in-out
               transform origin-center will-change-transform hover:scale-75 group"
                  >
                    {/* Arrow that slides left on hover out */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="md:h-20 md:w-20 w-14 h-14 absolute opacity-100 group-hover:opacity-0 group-hover:-translate-x-10
                 transition-all duration-300 ease-in-out text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>

                    {/* Arrow that comes in from right on hover */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="md:h-20 md:w-20 w-14 h-14 absolute opacity-0 group-hover:opacity-100 group-hover:translate-x-0 translate-x-10
                 transition-all duration-300 ease-in-out text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>
                </div>
              )
            ) : (
              <Link to="/" onClick={handleLogoClick}>
                <img src={logo} alt="Citrus Diagnostic Center" data-aos="fade-up" />
              </Link>
            )}
          </div>
          <div className="mt-2">
            <div className="flex flex-row gap-2 z-0 font-Matter">
              {topNav || window.innerWidth < 768 || isScrolled ? null : (
                <>
                  <Link to="/contact ">
                    <button className="group relative inline-flex h-[3.5rem] w-full items-center rounded-full px-10 py-[2.3rem] text-sm md:text-[1.2rem] font-bold text-white bg-transparent overflow-hidden mt-1">
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>
                      <span className="relative">
                        <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Contact Us Now
                        </span>
                        <span className="absolute flex flex-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Contact Us Now
                        </span>
                      </span>
                    </button>
                  </Link>
                  <Link
                    to="/make-a-payment"
                    className="nav-cta button button-outlined"
                    data-button-svg=""
                    style={{
                      color: location.pathname.startsWith("/services/")
                        ? "black"
                        : undefined,
                    }}
                  >
                    <span className="button-inner ">
                      <span className="button-inner-static">
                        Make a Payment
                      </span>
                      <span className="button-inner-hover">Make a Payment</span>
                    </span>
                    <span>
                      <svg
                        className="button-outlined-bg"
                        enableBackground="new 0 0 153.81333333333333 56"
                        viewBox="0 0 153.81333333333333 56"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <clipPath id="buttonSvg_U5NPDA2Q2">
                          <path
                            className="button-stroke"
                            d="m125.81333333333333 1c14.9 0 27 12.1 27 27s-12.1 27-27 27h-97.81333333333333c-14.9 0-27-12.1-27-27s12.1-27 27-27zm0-1h-97.81333333333333c-15.5 0-28 12.5-28 28 0 15.5 12.5 28 28 28h97.81333333333333c15.5 0 28-12.5 28-28 0-15.5-12.5-28-28-28z"
                          />
                        </clipPath>
                        <g clipPath="url(#buttonSvg_U5NPDA2Q2)">
                          <g className="button-circles">
                            <g className="button-circles-o">
                              <circle
                                pathLength="1"
                                className="button-circle -layer-1"
                                strokeWidth="153.81333333333333"
                                cx="76.90666666666667"
                                cy="28"
                                r="76.90666666666667"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-2"
                                strokeWidth="153.81333333333333"
                                cx="76.90666666666667"
                                cy="28"
                                r="76.90666666666667"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-3"
                                strokeWidth="153.81333333333333"
                                cx="76.90666666666667"
                                cy="28"
                                r="76.90666666666667"
                              />
                              <circle
                                pathLength="1"
                                className="button-circle -layer-4"
                                strokeWidth="153.81333333333333"
                                cx="76.90666666666667"
                                cy="28"
                                r="76.90666666666667"
                              />
                            </g>
                            <circle
                              pathLength="1"
                              className="button-circle -hover"
                              strokeWidth="153.81333333333333"
                              cx="76.90666666666667"
                              cy="28"
                              r="76.90666666666667"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                  </Link>
                </>
              )}

              <div className="">
                <button className="xiubfib vklmzv rounded-full bg-red-400 cursor-pointer z-40">
                  <span className="qopmxk rounded-full">
                    <span
                      className={`uweytn rounded-full ${
                        topNav ? "bg-white" : "bg-[#cfa751]"
                      }`}
                    >
                      <span className="vwuewq z-purple rounded-full"></span>
                      <span className="vwuewq z-turquoise rounded-full"></span>
                      <span className="vwuewq z-yellow rounded-full"></span>
                    </span>
                  </span>
                  <span className="qkxjwn rounded-full">
                    <span className="static-xt">
                      <label className="menuButton" htmlFor="check">
                        <input
                          type="checkbox"
                          id="check"
                          className="w-full"
                          checked={topNav}
                          onChange={() => setTopNav(!topNav)}
                        />
                        <span
                          className={`${
                            topNav ? "bg-black" : "bg-white"
                          } top cursor-pointer`}
                        ></span>
                        <span
                          className={`${
                            topNav ? "bg-black" : "bg-white"
                          } mid cursor-pointer`}
                        ></span>
                        <span
                          className={`${
                            topNav ? "bg-black" : "bg-white"
                          } bot cursor-pointer`}
                        ></span>
                      </label>
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={{
          height: 0,
          clipPath: "ellipse(100% 55% at 48% 44%)",
        }}
        animate={{
          height: topNav ? "100vh" : 0,
          clipPath: topNav
            ? [
                "ellipse(100% 55% at 48% 44%)",
                "ellipse(100% 80% at 50% 50%)",
                "inset(0% 0% 0% 0%)",
              ]
            : [
                "inset(0% 0% 0% 0%)",
                "ellipse(100% 80% at 50% 50%)",
                "ellipse(100% 55% at 48% 44%)",
              ],
        }}
        transition={{
          height: {
            type: "spring",
            stiffness: 200,
            damping: 30,
          },
          clipPath: {
            duration: 1.5,
            ease: "easeInOut",
          },
        }}
        className="w-full bg-[#fafaf6] fixed top-0 z-20 overflow-y-auto xl:overflow-hidden"
      >
        <div className="w-full h-auto lg:h-full flex lg:flex-row  flex-col-reverse pt-36">
          <div className="xl:w-4/5 lg:w-2/4 w-full h-full  flex items-end px-8  md:px-16 pt-14 pb-16 font-Matter">
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate={topNav ? "visible" : "hidden"}
            >
              <motion.p
                variants={itemVariants}
                className="text-[#cfa751] text-2xl md:text-[1rem] uppercase font-bold lg:font-semibold font-Matter tracking-[.2em]"
              >
                get in touch
              </motion.p>
              <motion.p
                variants={itemVariants}
                className="2xl:text-[2.5rem] sm:text-4xl text-xl mt-4"
              >
                <a href="mailto:cdc@gmail.com">cdc@gmail.com</a>
              </motion.p>
              <motion.p
                variants={itemVariants}
                className="2xl:text-[2.5rem] sm:text-4xl text-xl mt-2 xl:mt-6"
              >
                <a href="tel:352-795-9200">352-795-9200</a>
              </motion.p>
              <motion.p
                variants={itemVariants}
                className="text-lg 2xl:text-2xl font-normal leading-normal  mt-5"
              >
                <Link
                  to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
                  target="blank"
                >
                  922 North Citrus Avenue <br />
                  Crystal River, Florida 34428
                </Link>
              </motion.p>
            </motion.div>
          </div>
          <div className="w-full flex flex-col xl:pb-0 lg:pb-16  px-8  md:px-16 lg:px-0 lg:pt-0 items-start  xl:justify-start justify-end">
            {menuItems.map((item, index) => (
              <div
                key={item.text}
                className="relative group"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
              >
                {item.text === "portal" ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`3xl:text-[6.5rem] 2xl:text-[4.5rem] xl:text-6xl lg:text-[55px] md:text-6xl text-[2rem] font-bold tracking-[-.05em] xl:leading-[5.5vw] flex transition-all hover:duration-200 font-Antique  ${
                      activeDropdown === index && item.dropdown
                        ? "text-[#cfa751]"
                        : "hover:text-[#cfa751]"
                    }`}
                    onClick={() => {
                      setTopNav(false);
                    }}
                  >
                    {item.chars.map((char, i) => (
                      <motion.span
                        key={`${item.text}-${i}`}
                        custom={i}
                        variants={wordVariants}
                        initial="hidden"
                        animate={topNav ? "visible" : "hidden"}
                        className={char === " " ? "w-4 " : ""}
                      >
                        {char}
                      </motion.span>
                    ))}
                  </a>
                ) : (
                  <Link
                    to={item.link}
                    className={`3xl:text-[6.5rem] 2xl:text-[4.5rem] xl:text-6xl lg:text-[55px] md:text-6xl text-[2rem] font-bold tracking-[-.05em] xl:leading-[5vw] 3xl:leading-[5.5vw] flex transition-all hover:duration-200 font-Antique ${
                      activeDropdown === index && item.dropdown
                        ? "text-[#cfa751]"
                        : "hover:text-[#cfa751]"
                    }`}
                    onClick={() => {
                      if (
                        item.text === "for clinicians" ||
                        item.text === "for patients"
                      ) {
                        handleDropdownToggle(index);
                      } else {
                        handleDropdownToggle(index);
                        setTopNav(false);
                      }
                    }}
                  >
                    {item.chars.map((char, i) => (
                      <motion.span
                        key={`${item.text}-${i}`}
                        custom={i}
                        variants={wordVariants}
                        initial="hidden"
                        animate={topNav ? "visible" : "hidden"}
                        className={char === " " ? "w-4" : ""}
                      >
                        {char}
                      </motion.span>
                    ))}
                    {item.dropdown && window.innerWidth < 1024 && (
                      <motion.span
                        variants={wordVariants}
                        initial="hidden"
                        animate={topNav ? "visible" : "hidden"}
                        className="ml-2 text-[#cfa751]"
                      >
                        +
                      </motion.span>
                    )}
                  </Link>
                )}
                {item.dropdown && (
                  <>
                    <motion.div
                      variants={dropdownVariants}
                      initial="hidden"
                      animate={
                        activeDropdown === index && window.innerWidth >= 1024
                          ? "visible"
                          : "hidden"
                      }
                      className={`absolute bg-black text-white shadow-lg p-4 z-20 font-Antique rounded-lg lg:block hidden ${
                        item.text === "for clinicians"
                          ? "lg:-right-[15.5rem] xl:-right-[17rem] 2xl:-right-[18rem]  top-[2rem]"
                          : "-left-80 top-12"
                      }`}
                      style={{
                        transformOrigin:
                          item.text === "for clinicians"
                            ? "top left"
                            : "top right",
                      }}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={() => handleMouseLeave(index)}
                    >
                      <img
                        src={pinImage}
                        alt="pin"
                        className={`absolute w-14 h-14 ${
                          item.text === "for clinicians"
                            ? "-top-0 -left-10"
                            : "-top-10 -right-6"
                        }`}
                        style={{ transform: "rotate(180deg)" }}
                      />
                      {item.dropdown.map((dropdownItem, i) => (
                        <Link
                          key={dropdownItem.text}
                          to={dropdownItem.link}
                          onClick={() => {
                            setTopNav(false); // Close the menu
                          }}
                          className="block 3xl:text-xl text-lg font-medium capitalize text-white hover:text-[#cfa751] 3xl:py-1 py-0 cursor-pointer"
                        >
                          {dropdownItem.text}
                        </Link>
                      ))}
                    </motion.div>
                    <motion.div
                      variants={mobileDropdownVariants}
                      initial="hidden"
                      animate={
                        activeDropdown === index && window.innerWidth < 1024
                          ? "visible"
                          : "hidden"
                      }
                      className="bg-black text-white font-Antique px-2 rounded-3xl md:py-2 lg:hidden"
                    >
                      {item.dropdown.map((dropdownItem, i) => (
                        <HashLink
                          key={dropdownItem.text}
                          to={dropdownItem.link}
                          onClick={() => {
                            setTopNav(false); // Close the menu
                            handleDropdownToggle(index);
                          }}
                          className="text-xl font-medium flex flex-col capitalize text-white p-2 md:p-1 hover:text-[#cfa751] cursor-pointer"
                        >
                          {dropdownItem.text}
                        </HashLink>
                      ))}
                    </motion.div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default NavBar;
